module.exports = __webpack_public_path__ + "img/Default.eaef5a6b.png";